module.exports = __webpack_public_path__ + "img/product-banner_9.9f2f39b8.png";